import React from 'react';
import useGlobalStoreContext from '../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import { useOrganisationData } from '../../../Hooks/useOrganisation';
import useIsAppEnabled from '../../ApplicationSyncContext/useIsAppEnabled';
import useMultiLanguageContext from '../../MultiLanguageContext/useMultiLanguageContext';
import useSessionInfo from './useSessionInfo';

const CHANNEL = 'forward-state-to-app';

export default function useForwardState() {
  const session = useSessionInfo();
  const { language } = useMultiLanguageContext();
  const { projectId: [projectId] } = useGlobalStoreContext();
  const isAppEnabled = useIsAppEnabled();
  const sessionId = session?.id;
  const org = useOrganisationData();
  const liveConfig = org.features.cogneedAi?.dualChannel?.live;

  React.useEffect(() => {
    if (!sessionId || !window.electronUiAPI) return;
    if (liveConfig?.focusOnCallStart) {
      window.electronUiAPI.uiShow('home', true);
    } else if (liveConfig?.openOnCallStart) {
      window.electronUiAPI.uiShow('home', false);
    }
  }, [sessionId, liveConfig?.focusOnCallStart, liveConfig?.openOnCallStart]);

  React.useEffect(() => {
    if (isAppEnabled && window.electronMessagingApi) {
      const payload = {
        ...projectId !== undefined && { projectId },
        ...session !== undefined && { session },
        ...language !== undefined && { language },
      };
      window.electronMessagingApi.sendMessage(CHANNEL, payload);

      const port = window.electronMessagingApi.subscribeToMessageChannel(`${CHANNEL}-init`);
      port.addEventListener('message', () => {
        setTimeout(() => {
          window.electronMessagingApi?.sendMessage(CHANNEL, payload);
        }, 500);
      });
      port.start();
      return () => { port.close(); };
    }
    return undefined;
  }, [session, language, projectId, isAppEnabled]);
}
